import { adminBffClient } from 'services';
import { takeEvery, call } from '@redux-saga/core/effects';
import { reportMessage } from 'lib/error';
import { sendPushNotification } from './slice';

export function* handleSendPushNotification({ payload: { provider, assetId, notificationBody } }) {
    try {
        yield call(adminBffClient.sendPushNotification, { provider, assetId, notificationBody });
    } catch (error) {
        const message = 'Failed sending push notification';
        reportMessage({
            message,
            error,
        });
        Notification.notify.error(message);
    }
}

export default [takeEvery(sendPushNotification, handleSendPushNotification)];
